import { render, staticRenderFns } from "./MainReplyModal.vue?vue&type=template&id=5ad2fe8a&scoped=true&"
import script from "./MainReplyModal.vue?vue&type=script&lang=js&"
export * from "./MainReplyModal.vue?vue&type=script&lang=js&"
import style0 from "./MainReplyModal.vue?vue&type=style&index=0&id=5ad2fe8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad2fe8a",
  null
  
)

export default component.exports